// ** Kameralar
const initialState = {
  initialJinoyatchilik: {},
  jinoyatchilik_date: null,
  robbery_date: null
}

const jinoyatchilar = (state = initialState, action) => {
  switch (action.type) {
    case "SET_JINOYATCHILIK_TYPES_CONTENT":
      return { ...state, initialJinoyatchilik: action.val }
    case "SET_JINOYATCHILIK_DATE":
      return { ...state, jinoyatchilik_date: action.val }
    case "SET_ROBBERY_DATE":
      return { ...state, robbery_date: action.val }
    default:
      return state
  }
}

export default jinoyatchilar
